import {action, observable, when} from 'mobx';
import bind from 'bind-decorator';

export class MobxRequestable<T>
{
    @observable
    private _isRequestDone:boolean = false;

    @observable
    private _request:T = null;

    @action.bound
    public request(request:T)
    {
        this._request = request;

        when( ()=>(this._isRequestDone),
              action(()=>
              {
                    this._request = null;
                    this._isRequestDone = false;
              }));
    }

    @bind
    public markRequestDone(delayInMs:number)
    {
        setTimeout(action(()=>
        {
            this._isRequestDone = true;
        }),
        delayInMs);
    }

    @bind
    public getRequest():T | null
    {
        return this._request;
    }
}
